import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, A11y } from 'swiper/modules';

export default {
	init() {
		var $sliders = $('.testi-slider.w-slider');
		if (!$sliders.length) {
			return;
		}

		function updateAria(swiper) {
			var total = swiper.slides.length;
			swiper.slides.forEach(function (slide, index) {
				slide.setAttribute('aria-hidden', index !== swiper.activeIndex ? 'true' : 'false');
			});
			var $dots = $(swiper.pagination.el).find('.w-slider-dot');
			$dots.each(function (index) {
				var isActive = index === swiper.activeIndex;
				this.setAttribute('aria-pressed', isActive ? 'true' : 'false');
				this.setAttribute('tabindex', isActive ? '0' : '-1');
				this.setAttribute('aria-label', 'Show slide ' + (index + 1) + ' of ' + total);
			});
			var $ariaLabel = $(swiper.el).find('.w-slider-aria-label');
			if ($ariaLabel.length) {
				$ariaLabel.text('Slide ' + (swiper.activeIndex + 1) + ' of ' + total + '.');
			}
		}

		$sliders.each(function () {
			var $slider = $(this);
			if ($slider.data('swiper-initialized')) {
				return;
			}

			var $mask = $slider.find('.w-slider-mask');
			if (!$mask.length) {
				return;
			}

			var autoplayEnabled = $slider.attr('data-autoplay') === 'true';
			var autoplayDelay = parseInt($slider.attr('data-delay'), 10);
			var speed = parseInt($slider.attr('data-duration'), 10);
			var infinite = $slider.attr('data-infinite') === 'true';
			var animation = $slider.attr('data-animation');
			var fade = animation === 'fade' || animation === 'cross';

			var autoplayConfig = false;
			if (autoplayEnabled) {
				var resolvedDelay = Number.isFinite(autoplayDelay) ? autoplayDelay : 5000;
				autoplayConfig = {
					delay: resolvedDelay,
					disableOnInteraction: false,
				};
			}

			var $nav = $slider.find('.w-slider-nav');
			if ($nav.length) {
				$nav.empty();
			}

			var swiper = new Swiper($slider[0], {
				modules: [Navigation, Pagination, Autoplay, EffectFade, A11y],
				wrapperClass: 'w-slider-mask',
				slideClass: 'w-slide',
				slidesPerView: 1,
				slidesPerGroup: 1,
				loop: infinite,
				speed: Number.isFinite(speed) ? speed : 500,
				effect: fade ? 'fade' : 'slide',
				fadeEffect: { crossFade: true },
				autoplay: autoplayConfig,
				navigation: {
					prevEl: $slider.find('.w-slider-arrow-left')[0],
					nextEl: $slider.find('.w-slider-arrow-right')[0],
				},
				pagination: {
					el: $nav[0],
					clickable: true,
					bulletClass: 'w-slider-dot',
					bulletActiveClass: 'w-active',
					renderBullet: function (index, className) {
						return (
							'<div class="' +
							className +
							'" data-wf-ignore role="button" tabindex="-1"></div>'
						);
					},
				},
				a11y: {
					enabled: true,
				},
				on: {
					init: function () {
						updateAria(this);
					},
					slideChange: function () {
						updateAria(this);
					},
				},
			});

			$slider.data('swiper-initialized', true);
			$slider.data('swiper', swiper);
		});
	},
};
